import 'styles/NavBar.scss';
import AppContext from 'AppContext';
import { useContext } from 'react';

const navItems = [
  { mode: 'PROFILE', label: 'About'   },
  { mode: 'MAIN',    label: 'Work'    },
  { mode: 'CONTACT', label: 'Contact' },
  // { mode: 'ARTICLE', label: 'Blog'    },
];

const NavBar = () => {
  const { visMode, switchMode } = useContext(AppContext);

  return (
    <nav className='nav-container'>
      <button className='nav-brand' onClick={() => switchMode('PROFILE')}>
        Ian <span className='nav-brand-accent'>Laksono</span>
      </button>
      <div className='nav-links'>
        {navItems.map(({ mode, label }) => (
          <button
            key={mode}
            className={`nav-link${visMode === mode ? ' nav-link-active' : ''}`}
            onClick={() => switchMode(mode)}
          >
            {label}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default NavBar;
